module.exports = __webpack_public_path__ + "img/xy_grey.02f9a374.png";